<template>
    <Bar
        id="my-chart-id"
        :chart-options="chartOptions"
        :chart-data="chartData"
        :width="width"
        :height="height"
    />
</template>

<script>
import {Bar} from 'vue-chartjs/legacy';
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: 'BarChart',
    props: ['chartData', 'chartOptions',],
    components: {Bar},
    data() {
        return {
            width: 400,
            height: 400,
        }
    }
}
</script>
